import React, { createContext, useContext, ReactNode, useState } from "react";
import { USER } from "../constants/userCred";
import { COMMON } from "../constants/common";

interface AuthContextType {
  userRole: string | null;
  updateUserRole: (data: any) => void;
  accessToken: null | string;
  updateAccessToken: (token: string | null) => void;
}

const AuthContext = createContext<AuthContextType>({
  userRole: null,
  updateUserRole: () => {},
  accessToken: null,
  updateAccessToken: () => {},
});

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [userRole, setUserRole] = useState<string | null>(() => {
    const storedRole = localStorage.getItem(USER.LS_USER_ROLE_KEY);
    return storedRole ? JSON.parse(storedRole) : null;
  });
  const [accessToken, setAccessToken] = useState<string | null>(
    localStorage.getItem(COMMON.ACCESS_TOKEN)
      ? localStorage.getItem(COMMON.ACCESS_TOKEN)
      : null
  );

  const updateUserRole = (role: string) => {
    setUserRole(role);
    localStorage.setItem(USER.LS_USER_ROLE_KEY, JSON.stringify(role));
  };

  const updateAccessToken = (token: string | null) => {
    setAccessToken(token);
    if (token) {
      localStorage.setItem(COMMON.ACCESS_TOKEN, token);
    } else {
      localStorage.removeItem(COMMON.ACCESS_TOKEN);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        userRole,
        updateUserRole,
        accessToken,
        updateAccessToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
